// extracted by css-extract-rspack-plugin
export default {"cls1":"Sidebar-cls1_8zh","cls2":"Sidebar-cls2_AtB Sidebar-cls1_8zh","showMobile":"Sidebar-showMobile_LXN"};